module.exports = __webpack_public_path__ + "d3bae70991ee5fe686bcc5291e207473.pdf";